import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import appConfig from '../../../../config/app-config';

const { address: API_URL, key: API_KEY } = appConfig.apis.convertXmlApiEnv;

interface ReceivablesDownloaderProps {
    sequencialNumber: number;
    receivablesCount: number;
    onDataLoaded?: (data: any) => void;
}

const ReceivablesDownloader: React.FC<ReceivablesDownloaderProps> = ({
    sequencialNumber,
    receivablesCount,
    onDataLoaded
}) => {
    useEffect(() => {        if (receivablesCount === 0 && sequencialNumber > 0) {
            downloadAndProcessJson();
        }
    }, [receivablesCount, sequencialNumber]);

    const formatDateToYYYYMMDD = (dateString: string): string => {
        if (!dateString) return "";
        try {
            // Extrair apenas YYYY-MM-DD sem conversão de timezone
            const match = dateString.match(/^(\d{4}-\d{2}-\d{2})/);
            return match ? match[1] : "";
        } catch {
            return "";
        }
    };

    const parseJsonToFlatStructure = (jsonData: any) => {
        const flatItems: any[] = [];

        if (jsonData.documents && Array.isArray(jsonData.documents)) {
            jsonData.documents.forEach((document: any) => {
                if (document.receivables && Array.isArray(document.receivables)) {
                    document.receivables.forEach((receivable: any) => {
                        flatItems.push({
                            document_id: document.document_id || "",
                            document_title: document.document_title || "",
                            cfop: document.cfop || "",
                            issue_date: formatDateToYYYYMMDD(document.issue_date),
                            xml_size_bytes: document.xml_size_bytes || 0,
                            assignor_name: document.assignor_name || "",
                            assignor_cnpj: document.assignor_cnpj || "",
                            debtor_cpf_cnpj: document.debtor_cpf_cnpj || "",
                            debtor_name: document.debtor_name || "",
                            debtor_email: document.debtor_email || "",
                            address_street: document.address_street || "",
                            address_number: document.address_number || "",
                            address_complement: document.address_complement || "",
                            address_district: document.address_district || "",
                            address_ibge_code: document.address_ibge_code || "",
                            address_city: document.address_city || "",
                            address_state: document.address_state || "",
                            address_zip_code: document.address_zip_code || "",
                            address_country: document.address_country || "",
                            address_phone: document.address_phone || "",
                            receivable_number: receivable.receivable_number || "",
                            receivable_due_date: formatDateToYYYYMMDD(receivable.due_date),
                            receivable_amount: receivable.amount || 0,
                            receivable_v_pag: receivable.v_pag || "",
                            receivable_nat_op: receivable.nat_op || "",
                            receivable_ind_pag: receivable.ind_pag || "",
                            disbursement_value: receivable.disbursement_value || 0,
                            fee_name: receivable.fee_name || "",
                            fee_value: receivable.fee_value || 0,
                            guarantee_percent: receivable.guarantee_percent || 0,
                            main_risk: "",
                            external_link: ""
                        });
                    });
                }
            });
        }

        const total = flatItems.reduce((sum, item) => sum + item.receivable_amount, 0);

        return {
            receivables: {
                quantity: flatItems.length,
                total: total,
                items: flatItems
            },
            total_amount: jsonData.total_amount || total,
            operation_code: jsonData.operation_code || ""
        };
    };

    const downloadAndProcessJson = async () => {
        try {
            const url = `${API_URL}/contract/${sequencialNumber}`;
            const response = await fetch(url, {
                headers: {
                    'x-api-key': API_KEY || ''
                }
            });

            if (response.ok) {
                const rawData = await response.json();
                const parsedData = parseJsonToFlatStructure(rawData);
                toast.success(`Dados carregados automaticamente da API para contrato ${sequencialNumber}`);
                onDataLoaded?.(parsedData);
            }
        } catch (error: unknown) {
            console.error('Erro ao carregar dados:', error);
        }
    };

    return null;
};

export default ReceivablesDownloader;